const checkboxDataWelcome = () => {
  const options = [
    {
      checkboxID: 1,
      title: "Address",
      value: "address",
    },
    {
      checkboxID: 2,
      title: "Name",
      value: "name",
    },
    {
      checkboxID: 3,
      title: "Gender",
      value: "gender",
    },
    {
      checkboxID: 4,
      title: "Email address",
      value: "emailAddress",
    },
    {
      checkboxID: 5,
      title: "Mobile Number",
      value: "mobileNumber",
    },
  ];
  return options;
};

module.exports = { checkboxDataWelcome };
